import {
    ApolloThemeType,
    ServiceType,
    ThemeType,
} from '@uipath/portal-shell-util';

import { Scope } from '../constants/constants';
import { SERVICE_IDS } from '../constants/defaultServiceOrder';
import { Service } from '../models/service';
import {
    currentGravatarStorageKey,
    currentTenantStorageKey,
} from '../utils/storageKeys';
import {
    getAccountName,
    getBaseUrl,
    getSpaceName,
    getTenantName,
} from '../utils/urlHelper';
import { State } from './types/state';

export const defaultActiveItems = [ SERVICE_IDS.home, SERVICE_IDS.help ];

export const defaultMenuItems: Service[] = [
    {
        id: 'home',
        name: 'Home',
        scope: Scope.Global,
        serviceType: ServiceType.cloudRpa,
        svg: 'home',
        url: '//portal_/home',
    },
    {
        id: 'help',
        isSetting: true,
        name: 'Help',
        scope: Scope.Global,
        serviceType: ServiceType.cloudRpa,
        svg: 'help',
        url: '//portal_/resourcecenter',
    },
];

export const defaultStoreValues: State = {
    active: getSpaceName() ?? '',
    enableThemeSwitcher: true,
    theme: '' as ApolloThemeType,
    selectedTheme: '' as ThemeType,
    tenantColor: null,
    appInsights: null,
    focusMode: false,
    isAppInsightsInitialized: false,
    isSignInInitialized: false,
    launchDarkly: null,
    mode: null,
    isHost: false,
    email: '',
    avatarUrl: localStorage.getItem(currentGravatarStorageKey) ?? '',
    activePortalSubMenu: null,
    activeMenuSurface: null,
    activePortalToolbarSurface: null,
    activeDropdownMenuSurface: null,
    locale: '',
    overrideLocale: '',
    organizationStandardUrl: '',
    baseUrl: getBaseUrl() ?? '',
    organizationId: '',
    connectionType: '',
    accountName: getAccountName() ?? '',
    fullName: '',
    userId: '',
    tenantList: [],
    menuItems: [],
    overrideServices: [],
    activeLogoUrl: '',
    accessToken: '',
    selfAuthAccessToken: '',
    currentTenant: getDefaultCurrentTenant(),
    tenantChangedEmitter: null,
    tenantsNotAvailableEmitter: null,
    logoutClickedEmitter: null,
    settingClickEmitter: null,
    lastEmittedTenant: null,
    handleItems: [],
    overrideAllNavItems: false,
};

export function getDefaultCurrentTenant() {
    return localStorage.getItem(currentTenantStorageKey) ?? getTenantName() ?? '';
}
